/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {PropertiesParticipations} from '../../core/_models'
import {useIntl} from 'react-intl'

type Props = {
  propertiesParticipations: PropertiesParticipations
}

const PropertiesFunctionCell: FC<Props> = ({propertiesParticipations}) => {
  const intl = useIntl()

  return (
    <div className='d-flex text-center justify-content-center'>
      <div className='d-flex flex-column'>
        <a href='' className='text-gray-800 fw-semibold fs-8 mb-1'>
          {propertiesParticipations.beneficiary === true && (
            <div
              className='badge badge-light-success fw-bolder fs-9'
              style={{
                whiteSpace: 'pre-line',
              }}
            >
              {intl.formatMessage({id: 'OWNER.BENEFICIARY'})}
            </div>
          )}
          {propertiesParticipations.beneficiary === false && (
            <div
              className='badge badge-light-primary fw-bolder fs-9'
              style={{
                whiteSpace: 'pre-line',
              }}
            >
              {intl.formatMessage({
                id: 'OWNER.TITLE',
              })}
            </div>
          )}
        </a>
      </div>
    </div>
  )
}

export {PropertiesFunctionCell}
